import type {
  TMyAssignmentCourseItem,
  TMyAssignmentCourseItemType,
} from '@crehana/compass.dashlets/my-assignment-courses-widget';
import { date } from '@crehana/utils';

import type { GetMyAssignedCoursesQueryQuery } from './graphql/get-my-assigned-courses-query.v5.generated';

export const getNodeData = (data?: GetMyAssignedCoursesQueryQuery) => {
  const courses = data?.foundation_home_user?.get_my_assigned_courses;
  return courses?.__typename === 'MyAssignedCourseList' ? courses : undefined;
};

export const getAssignedCoursesMap = (
  data: GetMyAssignedCoursesQueryQuery,
): TMyAssignmentCourseItem[] => {
  const nodeData = getNodeData(data);
  // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
  if (!nodeData?.edges) return [];

  return nodeData.edges.map(edge => ({
    id: parseInt(edge.node.id),
    title: edge.node.title || '',
    imageUrl: edge.node.image_url || '',
    required: edge.node.required || false,
    progress: Math.round(edge.node.progress || 0),
    isCertified:
      edge.node.is_certified === undefined ? null : edge.node.is_certified,
    duration: date.toMinutes(edge.node.duration || 0),
    courseType: edge.node.course_type as unknown as TMyAssignmentCourseItemType,
  }));
};
